import { lazy } from "react";


const routes = [
  {
    name: "login",
    path: "/",
    component: lazy(() => import("../modules/Login/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  // {
  //   name: "login",
  //   path: "/:companyName?/login",
  //   component: lazy(() => import("../modules/Login/index.js")),
  //   exact: true,
  //   wrapRoute: "AuthRoute",
  //   layout: "AuthLayout",
  // },
  {
    name: "login",
    path: "/:token",
    component: lazy(() => import("../modules/Login/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "forget password",
    path: "/forget-password",
    component: lazy(() => import("../modules/ForgetPassword/index.jsx")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "video call",
    path: `/video-call`,
    component: lazy(() => import("../modules/VideoChat/VideoChat.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "reset password",
    path: "/reset-password/:token",
    component: lazy(() => import("../modules/ResetPassword/index.js")),
    exact: true,
    // wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "forget password",
    path: "/forget-password",
    component: lazy(() => import("../modules/ForgetPassword/index.jsx")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "signin",
    path: "/signin",
    component: lazy(() => import("../modules/Login/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "login",
    path: "/login",
    component: lazy(() => import("../modules/Login/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "welcome",
    path: `/:companyName/welcome`,
    component: lazy(() => import("../modules/Welcome")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "message",
    path: `/:companyName/message/:userId`,
    component: lazy(() => import("../modules/Message")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "channel",
    path: `/:companyName/channels/:channelId`,
    component: lazy(() => import("../modules/Channel")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "thread",
    path: `/:companyName/unread/threads`,
    component: lazy(() => import("../modules/Thread")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "draft",
    path: `/:companyName/draft`,
    component: lazy(() => import("../modules/Draft")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "admin",
    path: `/admin`,
    component: lazy(() => import("../modules/AdminDashboard/AdminLayout.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",

  },
  {
    name: "dashboard",
    path: `/admin/dashboard`,
    component: lazy(() => import("../modules/DashboardModule/DashboardLayout.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",

  },
 
  {
    name: "settings",
    path: `/admin/settings`,
    component: lazy(() => import("../modules/SettingsModule/SettingsModule.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",

  },

  {
    name: "admin",
    path: `/admin/company-registartion`,
    component: lazy(() => import("../modules/AdminDashboard/CompanyRegistration.js")),
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
    exact: true,

  },
  {
    name: "admin",
    path: `/admin/company-employee`,
    component: lazy(() => import("../modules/AdminDashboard/CompanyEmployee.js")),
    layout: "AdminLayout",
    exact: true,
    wrapRoute: "ProtectedRoute",


  },
  {
    name: "admin",
    path: `/admin/company-List`,
    component: lazy(() => import("../modules/AdminDashboard/CompanyList.js")),
    layout: "AdminLayout",
    exact: true,
    wrapRoute: "ProtectedRoute",


  },
  {
    name: "admin",
    path: `/admin/Administrator`,
    component: lazy(() => import("../modules/AdminDashboard/Administrator.js")),
    layout: "AdminLayout",
    exact: true,
    wrapRoute: "ProtectedRoute",


  },

  
];

export default routes;
